var React = require('react');

function Localization (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0.000000, -6.000000)","strokeWidth":"3"},React.createElement("path",{"d":"M29,26 C29,27.6568542 27.6568542,29 26,29 L8,29 L2,35 L2,11 C2,9.34314575 3.34314575,8 5,8 L26,8 C27.6568542,8 29,9.34314575 29,11 L29,26 Z"})));
}

Localization.defaultProps = {"fill":"none","stroke":"currentColor","viewBox":"0 0 31 31"};

module.exports = Localization;

Localization.default = Localization;
